module.exports = __webpack_public_path__ + "public/files/img/fingerprint.07a573d2.png";